var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIngredientsActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0794 2.0969C11.9777 1.99114 11.8128 1.99114 11.7111 2.0969L2.13572 12.0553C2.03402 12.1611 2.03402 12.3326 2.13572 12.4383L10.9746 21.6307C11.0763 21.7365 11.2411 21.7365 11.3428 21.6307L20.9182 11.6723C21.0199 11.5665 21.0199 11.3951 20.9182 11.2893L12.0794 2.0969ZM10.6063 0.947855C11.3182 0.207486 12.4724 0.207486 13.1843 0.947855L22.0231 10.1402C22.735 10.8806 22.735 12.081 22.0231 12.8214L12.4477 22.7798C11.7358 23.5201 10.5816 23.5201 9.8697 22.7798L1.03087 13.5874C0.318975 12.847 0.318975 11.6466 1.03087 10.9063L10.6063 0.947855Z",
    fill: "#92C99A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4194 1.09288C17.6266 1.09288 17.8253 1.17848 17.9719 1.33086L21.6547 5.16101C21.9598 5.47831 21.9598 5.99275 21.6547 6.31005L19.445 8.60818C19.14 8.92549 18.6453 8.92549 18.3402 8.6082C18.0351 8.2909 18.0351 7.77645 18.3402 7.45915L19.9975 5.73555L17.4194 3.05443L15.7622 4.778C15.4571 5.0953 14.9624 5.09531 14.6573 4.77801C14.3522 4.46071 14.3522 3.94626 14.6573 3.62896L16.867 1.33086C17.0135 1.17849 17.2122 1.09288 17.4194 1.09288Z",
    fill: "#92C99A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.59381 10.3749C7.59381 9.92618 7.94359 9.56241 8.37506 9.56241H14.6251C15.0565 9.56241 15.4063 9.92618 15.4063 10.3749C15.4063 10.8236 15.0565 11.1874 14.6251 11.1874H8.37506C7.94359 11.1874 7.59381 10.8236 7.59381 10.3749Z",
    fill: "#92C99A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.59381 13.6249C7.59381 13.1762 7.94359 12.8124 8.37506 12.8124H10.4584C10.8899 12.8124 11.2396 13.1762 11.2396 13.6249C11.2396 14.0736 10.8899 14.4374 10.4584 14.4374H8.37506C7.94359 14.4374 7.59381 14.0736 7.59381 13.6249Z",
    fill: "#92C99A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8021 13.6249C12.8021 13.1762 13.1519 12.8124 13.5834 12.8124H14.6251C15.0565 12.8124 15.4063 13.1762 15.4063 13.6249C15.4063 14.0736 15.0565 14.4374 14.6251 14.4374H13.5834C13.1519 14.4374 12.8021 14.0736 12.8021 13.6249Z",
    fill: "#92C99A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIngredientsActive);
export default __webpack_public_path__ + "static/media/ingredients-active.d0b7fd820c342db81448ed582c8a44b2.svg";
export { ForwardRef as ReactComponent };